import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import withStore from '../hocs/withStore';
import getInjectors from './reducerInjectors';

/**
 * Dynamically injects a reducer
 *
 * @param {string} key A key of the reducer
 * @param {function} reducer A reducer that will be injected
 *
 */
export default ({ key, reducer }) =>
  (WrappedComponent) => {
    class ReducerInjector extends React.Component {
      constructor(props) {
        super(props);

        this.injectors = getInjectors(props.reduxStore);
        const { injectReducer } = this.injectors;
        injectReducer(key, reducer);
      }

      static WrappedComponent = WrappedComponent;

      static propTypes = {
        reduxStore: PropTypes.object.isRequired,
      };

      static displayName = `withReducer(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

      render() {
        const { reduxStore, ...props } = this.props;
        return <WrappedComponent {...props} />;
      }
    }

    return hoistNonReactStatics(withStore(ReducerInjector), WrappedComponent);
  };
